import React, { Component } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { path } from 'ramda';
import config from '../generated/config';

import Input from '../commons/component/input';
import Button from '../commons/component/button';
import Svg from '../commons/component/svg';
import Eye from '../icons/eye-svg';
import Error, { hasNamedError } from '../commons/component/error';
import { changeLogin } from '../api/customer/change-login';
import { getAllQueryParams } from '../commons/query';

import Recaptcha from '../commons/component/captcha/recaptcha';
import AempUserIcon from '../icons/aemp-user-icon';

class AlterarEmailComponent extends Component {
  constructor() {
    super();
    this.changeField = this.changeField.bind(this);
    this.hasError = this.hasError.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
  }
  state = {
    newLogin: '',
    emailConfirmation: '',
    password: '',
    showPassword: false,
    isFormSubmitting: false,
    isLoginChangedSuccessfully: false,
    errors: {}
  };

  render() {
    if (this.state.isLoginChangedSuccessfully) {
      return (
        <div id="results">
          <div className="cadastroForm-container">
            <h2 className="cadastroForm-title">
              <AempUserIcon />
              <span>Alterar e-mail</span>
            </h2>

            <div className="alert alert-success">
              <div className="alert-status">
                <Svg name="icon-alert-success" className="svg-icon svg-icon-sm" />
              </div>
              <div className="alert-content">
                <p>Seu e-mail foi alterado com sucesso</p>
              </div>
            </div>

            <Button
              primary
              onClick={() => {
                window.location = `${path(['url', 'home'], config)}`;
              }}
              className="cadastroForm-submit"
            >
              Retornar a página inicial
            </Button>
          </div>
        </div>
      );
    }

    return (
      <div className="cadastroForm-container">
        <h2 className="cadastroForm-title">
          <AempUserIcon />
          <span>Alterar e-mail</span>
        </h2>

        <p className="paragraph">Informe o novo e-mail para sua conta</p>

        <form className="cadastroForm" onSubmit={this.updateEmail.bind(this)}>
          <div className="inputGroup" id="newLogin">
            <label className="inputGroup-label" htmlFor="new-login-input">
              Novo e-mail
            </label>
            <Input
              name="newLogin"
              id="new-login-input"
              placeholder="Ex. joaodasilva@gmail.com"
              data-form="signup"
              data-page="signup"
              type="email"
              onChange={this.changeField('newLogin')}
              value={this.state.newLogin}
              className={`inputGroup-input --large ${this.hasError('newLogin')}`}
            />
            <Error errors={this.state.errors} name="newLogin" />
          </div>
          <div className="inputGroup" id="new-login-confirmation">
            <label className="inputGroup-label" htmlFor="new-login-confirmation-input">
              Confirme seu novo e-mail
            </label>
            <Input
              name="newLoginConfirmation"
              id="new-login-confirmation-input"
              placeholder="Ex. joaodasilva@gmail.com"
              data-form="signup"
              data-page="signup"
              type="email"
              onChange={this.changeField('newLoginConfirmation')}
              value={this.state.newLoginConfirmation}
              className={`inputGroup-input --large ${this.hasError('newLoginConfirmation')}`}
            />
            <Error errors={this.state.errors} name="newLoginConfirmation" />
          </div>
          <div className="inputGroup" id="password">
            <label className="inputGroup-label" htmlFor="password">
              Senha
            </label>
            <Input
              name="password"
              id="password-input"
              data-form="signup"
              data-page="signup"
              type={this.state.showPassword ? 'text' : 'password'}
              onChange={this.changeField('password')}
              value={this.state.password}
              className={`inputGroup-input --withAddOn ${this.hasError('password')}`}
              autoComplete={false}
            />
            <span className="inputGroup-addOn" onClick={this.toggleShow('showPassword')}>
              <Eye on={!this.state.showPassword} />
            </span>
            <Error errors={this.state.errors} name="password" />
          </div>

          {config.enableCaptchaOnChangeLogin && <Recaptcha ref={ref => (this.captcha = ref)} />}

          <Button
            primary
            disabled={this.state.isFormSubmitting}
            loading={this.state.isFormSubmitting}
            className="cadastroForm-submit"
          >
            Salvar
          </Button>
          <Error errors={this.state.errors} name="errorMessage" />
        </form>
      </div>
    );
  }

  async updateEmail(evt) {
    try {
      evt.preventDefault();

      if (this.state.newLogin === this.state.newLoginConfirmation) {
        this.setState({ isFormSubmitting: true });
        const { token } = getAllQueryParams();
        const captchaResponse = config.enableCaptchaOnChangeLogin
          ? await this.captcha.getResponse()
          : '';
        const { errors } = await changeLogin(
          this.state.newLogin,
          this.state.password,
          token,
          captchaResponse
        );

        if (errors) {
          throw errors;
        } else {
          this.setState({ isLoginChangedSuccessfully: true });
        }
      } else {
        this.setState({
          errors: { newLoginConfirmation: 'E-mail não confere. Por favor, corrija o e-mail!' },
          isFormSubmitting: false
        });
      }
    } catch (errors) {
      console.error(errors);
      if (errors !== 'request timeout' && config.enableCaptchaOnChangeLogin) {
        this.captcha.reset();
      }

      this.setState({ errors, isFormSubmitting: false });
    }
  }

  hasError(name) {
    return hasNamedError(name, this.state.errors) ? '--hasError' : '';
  }

  changeField(name) {
    return e =>
      this.setState({
        ...this.state,
        [name]: e.target.value
      });
  }

  toggleShow(name) {
    return e =>
      this.setState({
        [name]: !this.state[name]
      });
  }
}

class AlterarEmailContainer extends React.Component {
  render() {
    return (
      <Switch>
        <Route
          path="/alterar-email"
          children={() => <AlterarEmailComponent history={this.props.history} />}
        />
        <Redirect to="/alterar-email" />
      </Switch>
    );
  }
}

export default withRouter(AlterarEmailContainer);
